<template>
    <div class="menu-list-container">
        <div class="checkin-overview-list">
            <div class="overview-header">
                <div class="header-item">菜品名称</div>
                <div class="header-item">餐次</div>
                <div class="header-item">类别</div>
                <div class="header-item">价格</div>
                <div class="header-item">图片</div>
            </div>
            <!-- 滚动列表的视窗容器 -->
            <div class="marquee-container">
                <div class="overview-body">
                    <div class="overview-row" v-for="(item, index) in menuList" :key="index">
                        <div class="body-item">{{ item.dishName }}</div>
                        <div class="body-item">{{ item.mealPeriod }}</div>
                        <div class="body-item">{{ item.dishType }}</div>
                        <div class="body-item">{{ item.price }}</div>
                        <div class="body-item">
                            <div class="image-container">
                                <img v-if="item.coverImg" :src="item.coverImg" alt="菜品图片" class="preview-image">
                                <div v-else class="no-image">
                                    <i class="el-icon-picture-outline"></i>
                                    <span>暂无图片</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 【修正】检查 menuList 并修改提示文本 -->
                    <div class="empty-tip" v-if="menuList.length === 0">
                        暂无今日菜品
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getTodayDish } from "@/api/index";

export default {
    name: 'TodayMenuList',
    data() {
        return {
            // 用于存储从API获取的菜品列表
            menuList: [],
            // 用于存储当前是星期几（例如："星期一"）
            selectedDay: ''
        };
    },
    created() {
        // 1. 组件创建时，自动获取今天是星期几
        this.setToday();
        // 2. 获取今日菜品列表
        this.getList();
    },
    methods: {
        /**
         * 设置 selectedDay 为今天的星期几
         */
        setToday() {
            const dayNames = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
            const today = new Date();
            const dayOfWeek = today.getDay(); // getDay() 返回 0 (周日) 到 6 (周六)
            this.selectedDay = dayNames[dayOfWeek];
        },

        /**
         * 从API获取今日菜品列表
         */
        getList() {
            // 显示加载状态（如果需要）
            this.menuList = [];

            // 发送API请求
            getTodayDish({
                userId: localStorage.getItem('userId'),
            }).then(response => {
                // 假设API返回的数据在 response.data 中
                // 请根据您的实际API返回结构进行调整
                this.menuList = response.data || [];
                console.log('今日菜品列表加载成功:', this.menuList);
            }).catch(error => {
                console.error('加载今日菜品列表失败:', error);
                // 可以在这里给用户一个错误提示
                // this.$message.error('加载今日菜品失败，请稍后重试');
            });
        }
    }
}
</script>

<style scoped>
.menu-list-container {
    padding: 0;
    flex: 1;
    /* 让容器填满父元素的可用空间 */
    display: flex;
    flex-direction: column;

}

.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    /* 隐藏滚动条 */
}

.overview-header {
    display: flex;
    background-color: #f8f9fa;
    font-weight: 600;
    padding: 12px 0;
    border-bottom: 1px solid #ebeef5;
    z-index: 10;
    /* 确保表头在滚动内容之上 */
}

.header-item {
    flex: 1;
    text-align: center;
    color: #333;
}

/* 滚动列表的视窗容器 */
.marquee-container {
    flex: 1;
    overflow: hidden;
    /* 关键：作为视窗，隐藏超出的内容 */
}

/* 应用动画的内部容器 */
.overview-body {
    /* 关键：应用动画 */
    animation: scroll-up 30s linear infinite;
}

/* 鼠标悬停时暂停动画 */
.marquee-container:hover .overview-body {
    animation-play-state: paused;
}

.overview-row {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px dashed #f0f0f0;
}

.body-item {
    flex: 1;
    text-align: center;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.preview-image {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
}

.no-image {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #999;
    font-size: 12px;
}

.no-image i {
    font-size: 20px;
    margin-bottom: 4px;
}

.empty-tip {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #999;
}

/* 定义滚动动画 */
@keyframes scroll-up {
    0% {
        transform: translateY(0);
    }

    100% {
        /* 关键：向上移动自身的 100% 高度 */
        transform: translateY(-100%);
    }
}
</style>